import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TransactionStatus } from '@rd/types';
import { UserInfoState } from '../reducers/user-info.reducer';

export const getUserInfoState =
  createFeatureSelector<UserInfoState>('userInfo');

export const getUserInfoData = createSelector(
  getUserInfoState,
  (state: UserInfoState) => state.data,
);

export const getUserInfoLoading = createSelector(
  getUserInfoState,
  (state: UserInfoState) => state.status === TransactionStatus.LOADING,
);

export const getUserInfoSuccess = createSelector(
  getUserInfoState,
  (state: UserInfoState) => state.status === TransactionStatus.SUCCESS,
);

export const getUserInfoFail = createSelector(
  getUserInfoState,
  (state: UserInfoState) => state.status === TransactionStatus.FAIL,
);
